// Line types that carry their own VAT rate. Sections, subtotals, page breaks,
// descriptive lines & co. reset `vat_rate_id` on save, so a rate set on them
// would be dropped anyway.
export const VAT_BEARING_TYPES = ["product", "regular", "service", "bpu"]

// VAT rate a quote applies by default: the quote-wide rate picked in the form
// when there is one (`allow_bulk_vat_rate_on_quotes`), the site's rate
// otherwise.
export const quoteVatRate = (quote) =>
  quote?.vat_rate?.id ? quote.vat_rate : quote?.site?.vat_rate

// Applicable VAT rate for a quote line, given the quote's site and the picked
// product. Precedence (shared by the V1 form and the V3 builder):
//   1. the quote-wide rate when there is one, else the site's rate ("base")
//      when that base is 0% (a tax-exempt quote or site wins over everything)
//   2. else the product's own VAT rate
//   3. else the base
export const resolveVatRate = (site, product, quoteRate) => {
  const base = quoteRate?.id ? quoteRate : site?.vat_rate

  if (base?.percentage === 0)  return base
  if (product?.vat_rate?.id)   return product.vat_rate
  if (base)                    return base
  return undefined
}

// Whether a bulk VAT change may overwrite this line. A product line whose
// product carries its own VAT rate is "forced" and keeps it — unless the rate
// being applied is 0%, which wins over everything (same rule as above).
export const bulkVatRateApplies = (qline, vatRate) => {
  if (!VAT_BEARING_TYPES.includes(qline.type)) return false
  if (vatRate?.percentage === 0)               return true

  return !qline.product?.vat_rate?.id
}

export const applyVatRateToLines = (qlines, vatRate) =>
  qlines.map(qline =>
    !qline.destroyed && bulkVatRateApplies(qline, vatRate)
      ? {...qline, vat_rate: vatRate || {}}
      : qline
  )

export default resolveVatRate
